import { cached } from '@glimmer/tracking';

import CommonCollapsiblePillOptionsComponent from 'webapp/components/common/collapsible-pill-options';
import CustomMetricsEditActionsBaseComponent, {
	MAX_OPTIONS_SHOWN_ON_PAGE,
} from 'webapp/components/custom-metrics/edit/actions/base';
import type { Args as BaseArgs } from 'webapp/components/custom-metrics/edit/actions/base';

interface Args extends BaseArgs {
	isNew: boolean;
	sourceTypeKey?: string;
}

export default class CustomMetricsEditActionsHorizonComponent extends CustomMetricsEditActionsBaseComponent<Args> {
	origin = 'horizon_metric_builder';

	get sourceTypes(): string[] {
		return this.args.sourceTypeKey ? [this.args.sourceTypeKey] : [];
	}

	get showDuplicate(): boolean {
		return !this.args.isNew;
	}

	get showDelete(): boolean {
		return !this.args.isNew;
	}

	@cached
	get options() {
		const options = [];
		if (this.showGetAssistance) {
			options.push(this.getAssistanceAction);
		}
		if (this.showDuplicate) {
			options.push(this.duplicateAction);
		}
		if (this.showDelete) {
			options.push(this.deleteAction);
		}
		return options;
	}

	<template>
		<CommonCollapsiblePillOptionsComponent
			@itemsList={{this.options}}
			@maxVisibleItems={{MAX_OPTIONS_SHOWN_ON_PAGE}}
			@doAction={{this.doAction}}
		/>
	</template>
}
